// import { Outlet } from "react-router-dom";

// export default function PublicLayout() {
//   return <Outlet />;
// }


import { Outlet, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#050505] selection:bg-orange-500/30">
      <Helmet>
        {/* Global Schema for SEO */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "EnvDock",
            "applicationCategory": "DeveloperApplication",
            "description": "Secure secret management and environment variable synchronization."
          })}
        </script>
      </Helmet>

      <Outlet />

     
    </div>
  );
}